//#region IMPORT
import { useState, useRef } from 'react';
import SAT_BASIC_07 from './SAT_BASIC_07';
import { useNavigate } from 'react-router-dom';
import Commons from '../../../../Services/Common/Common';
import Global from '../../../../Services/Common/Global';
import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
import { Loading } from '../../../../Components/MUIs';
import { closeLoading, showLoading } from '../../../../Reducer/LoadingReducer';
import { useSave1, useSearch1, useSearch2 } from './SAT_BASIC_07_QUERY';
import { SAT_BASIC_07_Schema } from './SAT_BASIC_07_Schema';
import { useSave } from '../../../../hooks/useSaveN';
import usePartialRefresh from '../../../../hooks/usePartialRefresh';
//#endregion

// 화면 MENU_ID
const SCREEN_MENU_ID = 'SafetyHealthTraining';

function SAT_BASIC_07F(props) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { userInfo, lanInfo } = useSelector((state) => state.BaseInfo);
  const searchInfo = useSelector((state) => state.SearchInfo);

  // 교육자료 등록 그리드
  const gridRef1 = useRef(); // 교육현황 그리드
  const [rowData1, setRowData1] = useState([]); // 교육자료 그리드 데이터
  const [selectedRowData1, setSelectedRowData1] = useState([]); // 교육자료 그리드 클릭 시 데이터
  const [changedRowData1, setChangedRowData1] = useState([]); // 교육자료 그리드 변경 시 데이터
  const selectedRowNosRef = useRef(new Set());
  const lastCheckedIndexRef = useRef(null);
  const currentRowIndexRef = useRef(null);
  const { handlePartialRefresh } = usePartialRefresh({
    gridRef: gridRef1,
    changedRowData: changedRowData1,
    setChangedRowData: setChangedRowData1,
    setRowData: setRowData1,
    getKeyFromRow: (row) => row.chaebun,
    getKeyFromResult: (result) => result.chaebun,
  });
  //#region 조회

  const ResetLogicAll = () => {
    setRowData1([]);
    setSelectedRowData1([]);
    setChangedRowData1([]);
  };
  const { refetch: Search1 } = useSearch1({
    onSuccess: (rows) => {
      const processedData = rows.map((item) => {
        let alarmGubun = item.alarmGubun;
        if (alarmGubun) {
          const codeMap = {
            0: '7일전',
            1: '3일전',
            2: '1일전',
          };
          alarmGubun = codeMap[alarmGubun] || alarmGubun;
        }

        return {
          ...item,
          alarmGubun: alarmGubun,
        };
      });

      setRowData1(Commons.InsertNumber(processedData));
    },
  });
  const { runAsync: Search2Async } = useSearch2();

  const { runAsync: Save1Async } = useSave1();

  const { run: Save1 } = useSave({
    menuId: SCREEN_MENU_ID,
    requiredLabel: '변경 사항',
    schema: SAT_BASIC_07_Schema,

    getChangedRows: () => {
      const changedRows = [];
      gridRef1.current?.api?.forEachNode((node) => {
        if (node.data?.editYn === 'Y' && !node.data?.deleteYn) {
          changedRows.push(node.data);
        }
      });

      return changedRows;
    },

    requestSave: async (rows) => {
      if (!rows?.length) return;

      const calendarRows = await Search2Async();
      const calId =
        calendarRows?.find((v) => v.MAIN_CALENDAR === 'Y')?.CAL_ID ?? '0';

      const alarmGubunMap = { '7일전': '0', '3일전': '1', '1일전': '2' };
      const userGroups = new Map();

      rows.forEach((row) => {
        const userId = row.tpaUserId || row.TPA_USER_ID || row.USER_ID;
        if (!userId) return;

        if (!userGroups.has(userId)) {
          userGroups.set(userId, {
            tpaUserId: userId,
            alarmYn: row.alarmYn || row.ALARM_YN || 'N',
            alarmGubun: alarmGubunMap[row.alarmGubun] || row.alarmGubun || '0',
            calId: calId.toString(),
          });
        }
      });

      const rowsToSave = Array.from(userGroups.values());

      return await Save1Async(rowsToSave);
    },

    reset: ResetLogicAll,
    refresh: Search1,
    partialRefresh: ({ saveResult, changedRows }) =>
      handlePartialRefresh({
        saveResult,
        changedRows,
        searchLogic: Search1,
      }),
  });

  //#region 나머지 함수
  //인쇄 함수
  const PrintLogic1 = async () => {
    setLoading(true);
    dispatch(showLoading());

    try {
      // HeaderData 설정
      const headerData = {
        YEAR: searchInfo.year,
      };

      // TableData 매핑 (레포트 양식에 맞게)
      const tableData = rowData1
        .filter((row) => !row.deleteYn) // 삭제된 행 제외
        .map((row, index) => {
          // 알람 컬럼: "Y, 7일전 11-30" 형식으로 변환
          let alarmText = '';
          if (row.alarmYn === 'Y' || row.alarmYn === 'y') {
            const alarmGubun = row.alarmGubun || '';
            // ALARM_DATE가 있으면 MM-DD 형식으로 변환
            let alarmDateStr = '';
            if (row.alarmDate && dayjs(row.alarmDate).isValid()) {
              alarmDateStr = dayjs(row.alarmDate).format('MM-DD');
            } else if (
              row.completeDate &&
              dayjs(row.completeDate).isValid()
            ) {
              // ALARM_DATE가 없으면 COMPLETE_DATE 사용
              alarmDateStr = dayjs(row.completeDate).format('MM-DD');
            }

            if (alarmGubun && alarmDateStr) {
              alarmText = `Y, ${alarmGubun} ${alarmDateStr}`;
            } else if (alarmGubun) {
              alarmText = `Y, ${alarmGubun}`;
            } else {
              alarmText = 'Y';
            }
          } else if (row.alarmYn === 'N' || row.alarmYn === 'n') {
            alarmText = 'N';
          } else {
            alarmText = row.alarmYn || '';
          }

          return {
            NO: index + 1,
            USER_NM: row.userNm || '', // 성명
            DEP_NM: row.depNm || '', // 소속(팀명)
            POSITION: row.position || '', // 직급
            ETC_EDU_NM: row.etcEduNm || '', // 교육명
            EDU_COUNT: row.eduCount || 0, // 등록교육수
            COMPLETE_COUNT: row.completeCount || 0, // 이수완료건
            NO_COMPLETE_COUNT: row.noCompleteCount || 0, // 미이수건
            ALARM: alarmText, // 알람 (이수종료일 7일전, 3일전, 1일전) - "Y, 7일전 11-30" 형식
          };
        });

      const printData = {
        FileName: 'TRA_BASIC_07',
        HeaderData: JSON.stringify(headerData),
        TableData: JSON.stringify(tableData),
      };

      await Commons.Axios(
        'report',
        Global.base.useUrl + Global.urls.Reports.reports,
        printData
      ).then((response) => {
        const blobUrl = URL.createObjectURL(response.data);
        window.open(blobUrl, '_blank'); // 새 탭에서 열기
      });
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    } finally {
      setLoading(false);
      dispatch(closeLoading());
    }
  };

  const handleRowSelection = (rowData, rowIndex) => {
    currentRowIndexRef.current = rowIndex;
    // onSelectionChanged에서 처리하므로 여기서는 currentRowIndexRef만 업데이트
    // setSelectedRowData1은 onSelectionChanged에서 처리됨
  };

  const NewYnErrorMsg = () => {
    dispatch(
      showSnackbar({
        message: '데이터 입력중입니다. 저장 후 시도하세요.',
        type: 'warning',
      })
    );
  };

  //#endregion

  return (
    <div className="wrap">
      <SAT_BASIC_07
        navigate={navigate}
        userInfo={userInfo}
        lanInfo={lanInfo}
        rowData1={rowData1}
        setRowData1={setRowData1}
        selectedRowData1={selectedRowData1}
        setSelectedRowData1={setSelectedRowData1}
        changedRowData1={changedRowData1}
        setChangedRowData1={setChangedRowData1}
        showSnackbar={showSnackbar}
        dispatch={dispatch}
        searchRef={props.searchRef}
        filterClick7={props.filterClick7}
        setFilterClick7={props.setFilterClick7}
        searchClick7={props.searchClick7}
        setSearchClick7={props.setSearchClick7}
        addClick7={props.addClick7}
        setAddClick7={props.setAddClick7}
        saveClick7={props.saveClick7}
        setSaveClick7={props.setSaveClick7}
        deleteClick7={props.deleteClick7}
        setDeleteClick7={props.setDeleteClick7}
        printClick7={props.printClick7}
        setPrintClick7={props.setPrintClick7}
        // 함수
        validateSelection={props.validateSelection}
        ResetLogicAll={ResetLogicAll}
        SearchLogic1={Search1}
        SaveLogic1={Save1}
        PrintLogic1={PrintLogic1}
        // GridCheckBox 관련 props
        gridRef={gridRef1}
        selectedRowNosRef={selectedRowNosRef}
        lastCheckedIndexRef={lastCheckedIndexRef}
        handleRowSelection={handleRowSelection}
        NewYnErrorMsg={NewYnErrorMsg}
      />
      <Loading open={loading} />
    </div>
  );
}

export default SAT_BASIC_07F;
